import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, Accordion } from "react-bootstrap";
import SchemaInjector from '../utils/SchemaInjector';

const FAQ = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
        {
            "@type": "Question",
            "name": "¿Tenéis financiación?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí, en Manacars ofrecemos financiación a medida para todos nuestros vehículos, en colaboración con entidades financieras. Cuéntanos qué coche te interesa y te preparamos una simulación sin compromiso."
            }
        },
        {
            "@type": "Question",
            "name": "¿Dónde estáis?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Estamos en Carretera de Logroño, 4, Oyón (Álava), a solo 3 km de Logroño. Puedes visitarnos en persona o contactarnos por WhatsApp o teléfono."
            }
        },
        {
            "@type": "Question",
            "name": "¿Los coches tienen garantía?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí, todos los vehículos de ocasión y km 0 de Manacars incluyen garantía de 12 meses."
            }
        },
        {
            "@type": "Question",
            "name": "¿Hacéis entregas fuera de la zona?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí, hacemos entrega de vehículos en toda España."
            }
        },
        {
            "@type": "Question",
            "name": "¿Puedo tasar mi coche aunque no lo compre en Manacars?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sí, la tasación es gratuita y sin compromiso, tanto si buscas vender tu coche como si quieres cambiarlo por otro de nuestro inventario."
            }
        }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Preguntas Frecuentes | Manacars</title>
        <meta name="description" content="Encuentra respuestas a las preguntas más comunes sobre financiación, garantía, tasación y entrega de vehículos en Manacars." />
        <link rel="canonical" href="https://manacars.es/faq" />
      </Helmet>
      <SchemaInjector schema={faqSchema} />
      <div className="container" style={{paddingTop: '100px', paddingBottom: '50px'}}>
      <h1>Preguntas Frecuentes</h1>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <Card.Title>¿Tenéis financiación?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card.Text>
            Sí, en Manacars ofrecemos financiación a medida para todos nuestros vehículos, en colaboración con entidades financieras. Cuéntanos qué coche te interesa y te preparamos una simulación sin compromiso.
            </Card.Text>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <Card.Title>¿Dónde estáis?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card.Text>
            Estamos en Carretera de Logroño, 4, Oyón (Álava), a solo 3 km de Logroño. Puedes visitarnos en persona o contactarnos por WhatsApp o teléfono.
            </Card.Text>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <Card.Title>¿Los coches tienen garantía?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card.Text>
            Sí, todos los vehículos de ocasión y km 0 de Manacars incluyen garantía de 12 meses.
            </Card.Text>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <Card.Title>¿Hacéis entregas fuera de la zona?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card.Text>
            Sí, hacemos entrega de vehículos en toda España.
            </Card.Text>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <Card.Title>¿Puedo tasar mi coche aunque no lo compre en Manacars?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card.Text>
            Sí, la tasación es gratuita y sin compromiso, tanto si buscas vender tu coche como si quieres cambiarlo por otro de nuestro inventario.
            </Card.Text>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
    </>
  );
}

export default FAQ;
